import React, { ReactNode, useState } from "react";
import { OverlaySubjectContext, TOverlaySubject } from "../../../context/OverlaySubjectContext";

interface IProps {
    children: ReactNode;
}

export function OverlaySubjectContainer({ children } : IProps) {
    const [ subject, setSubject ] = useState<TOverlaySubject | undefined>();
    return (
        <OverlaySubjectContext.Provider value={{ subject, setSubject }}>
            {children}
        </OverlaySubjectContext.Provider>
    )
}
